import { render, staticRenderFns } from "./FrontFooter.vue?vue&type=template&id=4c52ed70&scoped=true&"
import script from "./FrontFooter.vue?vue&type=script&lang=js&"
export * from "./FrontFooter.vue?vue&type=script&lang=js&"
import style0 from "./FrontFooter.vue?vue&type=style&index=0&id=4c52ed70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c52ed70",
  null
  
)

export default component.exports